import React, { FC, ReactNode, useEffect } from 'react';

import { DictionaryItem } from '@/Types/api/Dictionaries';

import { StoreClusterModel } from '../model/StoreClusterModel';
import { InitialClusterState, storeClusterStoreSelectors } from '../model/StoreClusterStore';
import { StoreClusterFormDualListbox, StoreClusterFormHeader } from './components';
import S from './StoreClusterForm.module.scss';

interface StoreClusterFormProps {
    title: ReactNode;

    companies: DictionaryItem[];
    storeGroups: DictionaryItem[];
    stores: DictionaryItem[];

    busyCompaniesIds: number[];
    busyStoreGroupsIds: number[];
    busyStoresIds: number[];

    initialState: InitialClusterState;

    onSave: (cluster: StoreClusterModel) => void;
}

export const StoreClusterForm: FC<StoreClusterFormProps> = ({
    title,
    stores,
    storeGroups,
    companies,
    busyCompaniesIds,
    busyStoreGroupsIds,
    busyStoresIds,
    initialState,
    onSave,
}) => {
    const setCompanies = storeClusterStoreSelectors.use.setCompanies();
    const setStoreGroups = storeClusterStoreSelectors.use.setStoreGroups();
    const setStores = storeClusterStoreSelectors.use.setStores();

    const resetState = storeClusterStoreSelectors.use.resetState();

    const setInitialClusterState = storeClusterStoreSelectors.use.setInitialClusterState();

    const setBusyIds = storeClusterStoreSelectors.use.setBusyIds();

    useEffect(() => {
        setCompanies(companies);
        setStoreGroups(storeGroups);
        setStores(stores);

        setBusyIds(busyCompaniesIds, busyStoreGroupsIds, busyStoresIds);
    }, [companies, storeGroups, stores, setCompanies, setStoreGroups, setStores, setBusyIds, busyCompaniesIds, busyStoreGroupsIds, busyStoresIds]);

    useEffect(() => {
        setInitialClusterState(initialState);
    }, [initialState, setInitialClusterState]);

    useEffect(() => {
        return () => {
            resetState();
        };
    }, [resetState]);

    return (
        <div className={S.root}>
            <StoreClusterFormHeader title={title} onSave={onSave} />

            <StoreClusterFormDualListbox title="Available stores" placeholder="Search by name of store" />
        </div>
    );
};
